class EmailSignupBlock extends HTMLElement {
  constructor() {
    super();
    this.lastButtonWidth = 0;
    this.observer = undefined;

    this.adjustInputPadding = this.adjustInputPadding.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('.email-signup__button--integrated');
    this.input = this.querySelector('.email-signup__input');
    this.inputGroup = this.querySelector('.email-signup__input-group');
    this.form = this.querySelector('.email-signup__form');
    this.messageContainer = this.querySelector('.email-signup__message-container');
    this.thankYouUrl = this.querySelector('#thank-you-url')?.value || null;

    const isTextButton = this.button && this.button.classList.contains('email-signup__button--text');

    // --- Original integrated button padding logic ---
    if (this.button && this.input && this.inputGroup && isTextButton) {
      this.adjustInputPadding();

      this.observer = new ResizeObserver(() => {
        this.adjustInputPadding();
      });
      this.observer.observe(this.button);

      if ('fonts' in document) {
        document.fonts.ready.then(() => {
          this.adjustInputPadding();
        });
      }
    }

    // --- Add captcha + AJAX submission ---
    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit);
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.form) this.form.removeEventListener('submit', this.handleSubmit);
  }

  // --- Adjust padding for integrated buttons ---
  adjustInputPadding() {
    if (!this.button || !this.inputGroup) return;

    const buttonWidth = this.button.offsetWidth;

    if (buttonWidth !== this.lastButtonWidth) {
      this.lastButtonWidth = buttonWidth;
      this.inputGroup.style.setProperty('--button-actual-width', `${buttonWidth}px`);
    }
  }

  // --- Handle form submission ---
  handleSubmit(e) {
    e.preventDefault();

    const email = this.input.value.trim();
    if (!email) {
      this.messageContainer.innerHTML = `<div class="email-signup__message email-signup__message--error">Please enter your email.</div>`;
      return;
    }

    // Make sure reCAPTCHA is loaded
    if (typeof grecaptcha !== 'undefined') {
      grecaptcha.ready(() => {
        grecaptcha.execute('YOUR_RECAPTCHA_SITE_KEY', { action: 'email_signup' }).then((token) => {

          // Build FormData
          const formData = new FormData(this.form);
          formData.append('g-recaptcha-response', token);

          // Submit via AJAX
          fetch(this.form.action, {
            method: 'POST',
            body: formData,
            headers: { 'Accept': 'application/json' },
            credentials: 'same-origin',
          })
          .then(res => res.json())
          .then(data => {
            if (data.errors) {
              this.messageContainer.innerHTML = `<div class="email-signup__message email-signup__message--error">${data.errors.join('<br>')}</div>`;
            } else {
              this.messageContainer.innerHTML = `<div class="email-signup__message email-signup__message--success">Thank you! You are subscribed.</div>`;
              this.form.reset();

              // Redirect manually if thank-you URL is set
              if (this.thankYouUrl) {
                window.location.href = this.thankYouUrl;
              }
            }
          })
          .catch(err => {
            console.error(err);
            this.messageContainer.innerHTML = `<div class="email-signup__message email-signup__message--error">An error occurred. Please try again.</div>`;
          });

        });
      });
    } else {
      this.messageContainer.innerHTML = `<div class="email-signup__message email-signup__message--error">Captcha not loaded.</div>`;
    }
  }
}

// --- Register custom element ---
if (!customElements.get('email-signup-block')) {
  customElements.define('email-signup-block', EmailSignupBlock);
}
